<template>
  <div>
    <v-expansion-panels v-model="panel" multiple focusable>
      <v-expansion-panel
        v-for="(bookable, key) in bookableFindByIds(place.bookables)"
        :key="key"
      >
        <v-expansion-panel-header>
          <strong>{{ bookable.quantity }} {{ bookable.type }}</strong>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="2"><strong>{{$t('page-accommodation.section-manage-units.fields.unique-id.header')}}:</strong></v-col>
            <v-col cols="6"><strong>{{$t('page-accommodation.section-manage-units.fields.room-place-name.header')}}:</strong></v-col>
            <v-col cols="2" class="text-center">
              <strong>{{$t('page-accommodation.section-manage-units.fields.ical.header')}}:</strong>
            </v-col>
            <v-col cols="1">&nbsp;</v-col>
          </v-row>
          <unit
            v-for="(unit, key) in unitFindByIds(bookable.units)"
            :key="key"
            :unit="unit"
            :place="place"
            :rollingBookingRule="bookingRuleFindById(place.rollingBookingRule)"
          ></unit>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <br>
    <v-alert type="warning" v-if="!readyToPublish(place.id)">
      {{$t('page-accommodation.actions.publish.warning')}}
    </v-alert>
    <div>
      <confirmation
          :title="$t('page-accommodation.actions.publish.confirmation-header')"
          :submitHandler="publishSubmitHandler"
          :entity="place"
          >
          <template v-slot:activator="props">
              <v-btn
                color="primary"
                :disabled="readyToPublish(place.id) !== true"
                title="Publish Availability"
                @click.stop="props.showDialog"
                v-if="place.availability_calendar !== true">{{ $t('global-terms.publish') }}
              </v-btn>
          </template>
          <template v-slot:body>
              <p>{{ $t('page-accommodation.actions.publish.confirmation-body', { place_name: place.name }) }}</p>
          </template>
      </confirmation>
    </div>

    <bottom-navigation
      :back="(currentUserHasRole('Administrator') || currentUserHasRole('Membership')) ? { title: $t('global-terms.extras'), to: { name: 'place-extras-manage' } } : null"
    ></bottom-navigation>
  </div>
</template>

<script>
import { clone, isNil } from 'ramda'
import Confirmation from '@/components/dialogs/Confirmation'
import BottomNavigation from '@/components/layout/BottomNavigation'
import { mapState, mapActions } from 'pinia'
import { useAlertStore, useUnitStore, useBookableStore, usePlaceStore, useBookingRuleStore, useUserStore } from '@/stores'
import Unit from './components/Unit.vue'

export default {
  data () {
    return {
      panel: [],
    }
  },
  computed: {
    ...mapState(usePlaceStore, [
      'findByEzObjectId',
      'readyToPublish',
    ]),
    ...mapState(useBookableStore, {
      bookableFindByIds: 'findByIds',
    }),
    ...mapState(useUnitStore, {
      unitFindByIds: 'findByIds',
    }),
    ...mapState(useBookingRuleStore, {
      bookingRuleFindById: 'findById',
    }),
    ...mapState(useUserStore, ['currentUserHasRole']),
    hasRollingBookingRule () {
      return !isNil(this.place.rollingBookingRule) || false
    },
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(usePlaceStore, [
      'httpUpdatePlace',
    ]),
    ...mapActions(useAlertStore, [
      'setAlertError',
    ]),
    publishSubmitHandler (savedPlace) {
      let place = clone(savedPlace)
      place.availability_calendar = true
      return this.httpUpdatePlace({ place })
        .then(() => {
          this.tagManager.addEvent('Manage Availability', 'Save & Continue Button', this.place.name)
        })
    },
  },
  components: {
    Unit,
    Confirmation,
    BottomNavigation,
  },
  created () {
    // set all bookables to open
    this.panel.push(...this.place.bookables.keys())
  },
}
</script>
